import { Tabs } from '~/widgets/FreeParking/Tabs/Tabs';
import { Button } from '~/shared/ui/Button/Button';
import {
  cvaRentalPeriod,
  cvaRentalPeriodText,
} from '~/entities/RentalPeriod/RentalPeriodStyles';
import Calendar from 'public/icons/calendar.svg?react';
import { cvaIcon } from '~/shared/styles/IconStyles';
import { useStartDateStore } from '~/shared/store/startDateStore';
import { formatDate } from '~/shared/utils/dateFormatter';
import { isNextDay } from '~/shared/utils/isNextDay';
import { FC } from 'react';

interface Props {
  openStartDate: (isOpen: boolean) => void;
}

const isToday = (today: Date, startDate: Date) => {
  return (
    today.getFullYear() === startDate.getFullYear() &&
    today.getMonth() === startDate.getMonth() &&
    today.getDate() === startDate.getDate()
  );
};

export const RentalPeriod: FC<Props> = ({ openStartDate }) => {
  const { state } = useStartDateStore();

  return (
    <div className={cvaRentalPeriod()}>
      <p className={cvaRentalPeriodText()}>Срок аренды</p>
      <Tabs />
      <Button
        rubber
        onClick={() => openStartDate(true)}
        disabled={!state.startDate}
        size={'common'}
        variant={'darkGray'}
        icon={<Calendar className={cvaIcon({ iconSize: 'common' })} />}>
        {isNextDay(state.today, state.startDate)
          ? `C завтра, ${formatDate(state.startDate)}`
          : isToday(state.today, state.startDate)
            ? `C сегодня, ${formatDate(state.startDate)}`
            : `c ${formatDate(state.startDate)}`}
      </Button>
    </div>
  );
};
